import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import F3DScaleAItem from "@/components/subject/F3DScaleA/F3DScaleAItem.vue";
export default {
  name: "F3DScaleBRender",
  components: {
    F3DScaleAItem
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      answered: new Set()
    };
  },
  methods: {
    getChooseOf(answer, idx) {
      if (!answer) {
        return 0;
      }
      return answer.split(',').includes(idx.toString()) ? 1 : answer.split(',').includes((idx * -1).toString()) ? 2 : 0;
    },
    onAnswerChoosed(v) {
      this.answered.add(v);
      this.answered.delete(v * -1);
      this.$emit('answer', this.answered.size > 0 ? [...this.answered].join(',') : null);
    },
    clearChoose(v) {
      this.answered.delete(v);
      this.$emit('answer', this.answered.size > 0 ? [...this.answered].join(',') : null);
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};